import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    buildCountDocumentTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["документ", "документа", "документов"])}`,
    NO_DATA_TEXT: "Здесь пока нет документов"
};
